import { FamilyIcon } from '@repo/ui/icons'

import UserNavBar from '../../../components/elements/nav-bar'
import OlTeflTable from '../../../components/pages/ols/ol-tefl/ol-tefl-table'

const OLTeflGlobalListPage = () => {
  return (
    <div>
      <UserNavBar title={'TEFLS'} icon={FamilyIcon} />
      <div className="h-4" />
      <OlTeflTable mode="global" />
    </div>
  )
}

export default OLTeflGlobalListPage
